import { FC } from "react";
import { useAppSelector } from "@/store/hooks";

import { NormalizedCostWidgetTableView } from "@/components/pages/dashboard/components/widgets/normalized-cost-widget/components/table/NormalizedCostWidgetTableView";
import { normalizedCostWidgetByWidgetIdDataSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/widget-view/normalizedCostWidgetByWidgetIdDataSelector";
import { normalizedCostWidgetByWidgetIdLoadingSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/widget-view/normalizedCostWidgetByWidgetIdLoadingSelector";
import { normalizedCostWidgetVisualizationByIdSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/widget-view/normalizedCostWidgetVisualizationByIdSelector";

interface NormalizedCostWidgetContentTableViewProps {
  widgetId: string;
}

export const NormalizedCostWidgetContentTableView: FC<
  NormalizedCostWidgetContentTableViewProps
> = ({ widgetId }) => {
  const widgetData = useAppSelector((state) =>
    normalizedCostWidgetByWidgetIdDataSelector(state, widgetId),
  );
  const loading = useAppSelector((state) =>
    normalizedCostWidgetByWidgetIdLoadingSelector(state, widgetId),
  );
  const visualization = useAppSelector((state) =>
    normalizedCostWidgetVisualizationByIdSelector(state, widgetId),
  );

  return (
    <NormalizedCostWidgetTableView
      normalized={widgetData?.normalized}
      regular={widgetData?.regular_cost}
      loading={loading}
      visualization={visualization}
    />
  );
};
